import React from 'react'

export const decotrate = ({ DecoratorComponent, DecoratorFormComponent }, plugins) =>
    plugins.map(plugin => {
        if (plugin.legacy || false) {
            return plugin
        }

        const Component = plugin.Component

        const hasChildren = plugin.Component().props.hasOwnProperty('children')

        if (!hasChildren) {
            // Prevents the plugin being nested in the decorator multiple times
            plugin.Component = props => (
                <DecoratorComponent {...props}>
                    <Component {...props} />
                </DecoratorComponent>
            )
        }

        // plugin.decorated = true;
        plugin.DecoratedForm = DecoratorFormComponent

        return plugin
    })

export default (settings, plugins) => {
    const { content = [], layout = [] } = plugins

    plugins.content = decotrate(settings, content)
    plugins.layout = decotrate(settings, layout)

    return plugins
}
